"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_pause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "1e617327-8088-4868-b02d-6b143c9eb5c0",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fbec2621-8c5b-4043-ac58-4c0e8446b92d",
    x1: 97.65,
    y1: 122,
    x2: 97.65,
    y2: 175.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5775f66a-7bf1-4535-bbbd-a07280f1a9be",
    x1: 87.44,
    y1: 125.61,
    x2: 87.44,
    y2: 127.81,
    xlinkHref: "#fbec2621-8c5b-4043-ac58-4c0e8446b92d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e95e53a1-8023-4aea-8bd6-5a2180f62c68",
    x1: 83.93,
    y1: 127.81,
    x2: 83.93,
    y2: 131.96,
    xlinkHref: "#fbec2621-8c5b-4043-ac58-4c0e8446b92d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b9219811-f21e-4e7d-9e85-2e6b37226379",
    x1: 131.86,
    y1: 122,
    x2: 131.86,
    y2: 163.04,
    xlinkHref: "#fbec2621-8c5b-4043-ac58-4c0e8446b92d"
  })), /*#__PURE__*/React.createElement("title", null, "pause-hi"), /*#__PURE__*/React.createElement("g", {
    id: "11c07cad-0b4b-43ca-9bf3-7485e48b8225",
    "data-name": "filter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,16h0a80,80,0,0,1,80,80h0a80,80,0,0,1-80,80h0A80,80,0,0,1,16,96h0A80,80,0,0,1,96,16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,30",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,132H112a8,8,0,0,1-8-8V68a8,8,0,0,1,8-8h12a8,8,0,0,1,8,8v56A8,8,0,0,1,124,132Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,132H68a8,8,0,0,1-8-8V68a8,8,0,0,1,8-8H80a8,8,0,0,1,8,8v56A8,8,0,0,1,80,132Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,130H112a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8h12a8,8,0,0,0,8-8v-2A8,8,0,0,1,124,130Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,130H68a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8H80a8,8,0,0,0,8-8v-2A8,8,0,0,1,80,130Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174h0A80.23,80.23,0,0,1,16,95v1h0a80.24,80.24,0,0,0,80,80h0a80.24,80.24,0,0,0,80-80h0V95A80.23,80.23,0,0,1,96,174Z",
    transform: "translate(0 0)",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88,122v2a8.53,8.53,0,0,1-.16,1.61,8,8,0,0,1-7,6.35,7.38,7.38,0,0,1-.82,0H68a7.91,7.91,0,0,1-5.65-2.36c-.63-.62,45.3,45.51,45.3,45.51A79.44,79.44,0,0,0,133,167Z",
    transform: "translate(0 0)",
    fill: "url(#fbec2621-8c5b-4043-ac58-4c0e8446b92d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.84,125.61a8,8,0,0,1-.81,2.2A8,8,0,0,0,87.84,125.61Z",
    transform: "translate(0 0)",
    fill: "url(#5775f66a-7bf1-4535-bbbd-a07280f1a9be)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.82,132A8,8,0,0,0,87,127.81,8,8,0,0,1,80.82,132Z",
    transform: "translate(0 0)",
    fill: "url(#e95e53a1-8023-4aea-8bd6-5a2180f62c68)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.36,147.32,132,122v2a7.78,7.78,0,0,1-.16,1.61,7.93,7.93,0,0,1-.8,2.2,8,8,0,0,1-6.22,4.15,7.38,7.38,0,0,1-.82,0H112a7.94,7.94,0,0,1-5.65-2.36L139.63,163A80.3,80.3,0,0,0,157.36,147.32Z",
    transform: "translate(0 0)",
    fill: "url(#b9219811-f21e-4e7d-9e85-2e6b37226379)"
  }))));
}

var _default = ic_pause;
exports.default = _default;